import Category from "features/Category/CategoryList/Category";

const CategoryPage: React.FC = () => {
  return <Category />;
};

export default CategoryPage;
